export default __webpack_public_path__ + "static/media/streetview.ec732280.svg";